export default "__VITE_ASSET__BWVeglqE__"